<!-- Step 3 -->
<form [formGroup]="formGroup" class="gw-flex gw-flex-col gw-gap-x-large">
  <gatewee-input-v2
    [form]="formGroup"
    controlName="postalCode"
    [label]="'features.onboarding.addressForm.labels.postalCode' | translate"
    type="text"
    id="address-postalCode"
    mask="00000-000"
    [required]="true"
    (blur)="handlePostcode()"
  ></gatewee-input-v2>

  <div
    class="gw-grid gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="street"
      [label]="'features.onboarding.addressForm.labels.street' | translate"
      type="text"
      id="address-street"
      [required]="true"
    ></gatewee-input-v2>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="number"
      [label]="'features.onboarding.addressForm.labels.number' | translate"
      type="text"
      id="address-number"
    ></gatewee-input-v2>
  </div>

  <div
    class="gw-grid gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="complement"
      [label]="'features.onboarding.addressForm.labels.complement' | translate"
      type="text"
      id="address-complement"
    ></gatewee-input-v2>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="neighborhood"
      [label]="
        'features.onboarding.addressForm.labels.neighborhood' | translate
      "
      type="text"
      id="address-neighborhood"
      [required]="true"
    ></gatewee-input-v2>
  </div>

  <div
    class="gw-grid gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="city"
      [label]="'features.onboarding.addressForm.labels.city' | translate"
      type="text"
      id="address-city"
      [required]="true"
    ></gatewee-input-v2>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="state"
      [label]="'features.onboarding.addressForm.labels.state' | translate"
      type="text"
      id="address-state"
      [required]="true"
    ></gatewee-input-v2>
  </div>
</form>
